<Grid direction="row-reverse" class="tint tint--primary">

    <GridItem span="6-of-12" class="spacing spacing--padding-large">

        <div class="text text--align-justify text--max-line-length">

            <p>Ich arbeite in den Schwerpunkten <i>modeling</i>, <i>sculpting</i>, <i>texturing</i> und <i>shading</i>. Bei Bedarf übernehme ich auch <i>rigging</i> und <i>animation</i> (technisch, <i>matchmoving</i> und <i>character animation</i>).</p>
            
            <p>Durch die Arbeit an verschiedenen Produktionen und der Zusammenarbeit mit diversen Firmen habe ich vielseitige Erfahrungen gesammelt, die sich speziell im Bereich von Spielfilmen, Werbefilmen und Printkampagnen widerspiegeln.</p>

            <p>Hierdurch habe ich sehr gute Kenntnisse unter anderem in folgenden Softwarepaketen:</p>

            <Software shorthands={['maya', 'cinema4d', 'zbrush', 'houdini', 'mari', 'nuke', 'photoscan', 'photoshop']} />

            <p>Um Arbeitsschritte wie Dateiversionierung, Datenimport und -export zu vereinfachen und damit effektiver zu arbeiten, erstelle ich außerdem <i>scripts</i> und <i>plugins</i> in <strong>Python</strong> sowohl als <i>command line tools</i> als auch mit <i>GUI</i> in <strong>PySide</strong> und <strong>PyQt</strong>.</p>

            <p>Ich verfolge mit großem Interesse die Entwicklung neuer <i>workflows</i> und Programme und adaptiere diese für meine Projekte. Außerdem programmiere ich meine Website und arbeite an <i>open source</i> Projekten.</p>

            <p><a href="/files/bernhard_esperester_cv_2018.pdf" class="button button--info button--large button--highlight">Curriculum vitae</a></p>

        </div>

    </GridItem>

    <GridItem span="6-of-12">

        <Picture src="/img/bernhard_esperester.jpg" fit="cover" poiY={40} />

    </GridItem>

</Grid>

<script>
    // components
    import Grid from 'components/Grid.html'
    import GridItem from 'components/GridItem.html'
    import Picture from 'components/Picture.html'

    // compounds
    import Software from 'compounds/Software.html'

    export default {
        components: {
            Grid,
            GridItem,
            Picture,
            Software
        }
    }
</script>